/**
 * LocalController — Tastatur, Maus und Touch → PlayerInput.
 * Hält den Rohzustand der Geräte; main verdrahtet die DOM-Events.
 */
import type { Controller, ControlSelf, PlayerInput, WorldSense } from './PlayerControl';

export type LocalRaw = {
  keys: Set<string>;
  joyX: number;
  joyY: number;
  /** Weltkoordinaten oder null */
  aimWorld: { x: number; y: number } | null;
  /** einmalig konsumieren */
  fireQueued: boolean;
  switchQueued: boolean;
};

export function createLocalRaw(): LocalRaw {
  return {
    keys: new Set(),
    joyX: 0,
    joyY: 0,
    aimWorld: null,
    fireQueued: false,
    switchQueued: false,
  };
}

export class LocalController implements Controller {
  constructor(private raw: LocalRaw) {}

  getInput(_world: WorldSense, self: ControlSelf, _dt: number): PlayerInput {
    let moveX = 0;
    let moveY = 0;
    const k = this.raw.keys;
    if (k.has('KeyW') || k.has('ArrowUp')) moveY -= 1;
    if (k.has('KeyS') || k.has('ArrowDown')) moveY += 1;
    if (k.has('KeyA') || k.has('ArrowLeft')) moveX -= 1;
    if (k.has('KeyD') || k.has('ArrowRight')) moveX += 1;
    const kl = Math.hypot(moveX, moveY);
    if (kl > 0) {
      moveX /= kl;
      moveY /= kl;
    }
    if (Math.hypot(this.raw.joyX, this.raw.joyY) > 0.05) {
      moveX = this.raw.joyX;
      moveY = this.raw.joyY;
    }

    const fire = this.raw.fireQueued;
    this.raw.fireQueued = false;
    const ammoSwitch = this.raw.switchQueued;
    this.raw.switchQueued = false;

    const aim = this.raw.aimWorld;
    return {
      moveX,
      moveY,
      aimX: aim ? aim.x : undefined,
      aimY: aim ? aim.y : undefined,
      fire: fire && self.stunT <= 0,
      ammoSwitch,
    };
  }
}
